import { render, staticRenderFns } from "./payComplaints.vue?vue&type=template&id=4e287246&scoped=true"
import script from "./payComplaints.vue?vue&type=script&lang=js"
export * from "./payComplaints.vue?vue&type=script&lang=js"
import style0 from "./payComplaints.vue?vue&type=style&index=0&id=4e287246&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e287246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e287246')) {
      api.createRecord('4e287246', component.options)
    } else {
      api.reload('4e287246', component.options)
    }
    module.hot.accept("./payComplaints.vue?vue&type=template&id=4e287246&scoped=true", function () {
      api.rerender('4e287246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/payComplaints.vue"
export default component.exports